import TrashRed from "../../../assets/icons/TrashRed";

type BoardAdminProps = {
  img: string | undefined;
  name: string;
  onRemove: () => void;
};

export const BoardAdmin = ({ img, name, onRemove }: BoardAdminProps) => {
  return (
    <div className="flex bg-[#0068FF1A] bg-opacity-10 rounded-lg p-[5px] text-[#5F6B88] gap-2 w-fit items-center">
      <img className="w-6 h-6" src={img} alt={name} />
      <h2>{name}</h2>
      <button
        onClick={onRemove}
        className="text-[#AFB7CA] hover:text-red-500 transition"
      >
        <TrashRed />
      </button>
    </div>
  );
};
